document.addEventListener('click', (event) => {
  const parent = event.target.closest('.quantity')
  const button = event.target.closest('button[data-offset]')
  if (parent && button) {
    const input = parent.querySelector('input[data-quantity-input]')
    if (input) {
      const offset = parseInt(button.dataset.offset)
      const currentValue = parseInt(input.value)
      const newValue = currentValue + offset

      if (newValue > 0) {
        input.value = newValue
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }
  }
})
